module.exports = __webpack_public_path__ + "static/Hero-1_Mobile-22ff066481dbd4059a026ce38a22c8dc.jpg";